import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2a7ae1ee"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _createTextVNode("+86");
const _hoisted_2 = { class: "verify-code" };
const _hoisted_3 = {
    key: 0,
    class: "botton-box"
};
const _hoisted_4 = /*#__PURE__*/ _createTextVNode("取消");
const _hoisted_5 = /*#__PURE__*/ _createTextVNode("保存");
const _hoisted_6 = /*#__PURE__*/ _createTextVNode(" 确认 ");
import { ref, reactive, onBeforeUnmount, defineAsyncComponent, watch } from "vue";
import { ElForm } from "element-plus";
import PasswordCheck from "@/components/PasswordCheck/index.vue";
import CloudButton from "@/components/CloudButton/index.vue";
import { checkPassword, checkPhone, debounce, getMsg, useBcrypt } from "@/utils";
import { modifyPassword } from "@/service/login";
import { useCounterStore } from "@/store/user";
export default /*#__PURE__*/ _defineComponent({
    name: 'AdminChange',
    props: {
        isCancel: { type: Boolean },
        scenario: null
    },
    emits: ["success", "cancel"],
    setup(__props, { expose, emit }) {
        const props = __props;
        const userStore = useCounterStore();
        const userInfo = userStore.getUserInfo;
        const resetForm = ref(null);
        const password = ref("");
        const passwordVerify = ref("");
        const passwordShow = ref(false);
        const passwordVerifyShow = ref(false);
        const count = ref(60);
        const isSend = ref(false);
        let intervalId;
        const Captcha = defineAsyncComponent(() => import("@/components/CloudCaptcha/index.vue"));
        const resetData = reactive({
            phone: "",
            code: "",
            password: "",
            passwordVerify: ""
        });
        const checkSame = (rule, value, callback) => {
            if (value !== resetData.password) {
                callback(new Error("两次输入密码不一致!"));
            }
            else {
                callback();
            }
        };
        const resetRules = reactive({
            phone: [
                { required: true, message: "请输入手机号~", trigger: "blur" },
                { validator: checkPhone, trigger: "blur" }
            ],
            code: [{ required: true, message: "请输入验证码~", trigger: "blur" }],
            password: [
                { required: true, message: "请输入密码~", trigger: "blur" },
                { validator: checkPassword, trigger: "blur" }
            ],
            passwordVerify: [
                { required: true, message: "请再次输入密码~", trigger: "blur" },
                { validator: checkSame, trigger: "blur" },
                { validator: checkPassword, trigger: "blur" }
            ]
        });
        const submit = () => {
            if (resetForm.value) {
                resetForm.value.validate((valid) => {
                    if (valid) {
                        let params = {
                            phone: resetData.phone,
                            code: resetData.code,
                            new_password: useBcrypt(resetData.passwordVerify)
                        };
                        modifyPassword(params).then(() => {
                            emit("success");
                        });
                    }
                });
            }
        };
        const cancelHandle = () => {
            emit("cancel");
        };
        const focusHandle = (value) => {
            if (value === "password") {
                passwordShow.value = true;
            }
            else {
                passwordVerifyShow.value = true;
            }
        };
        const blurHandle = (value) => {
            if (value === "password") {
                passwordShow.value = false;
            }
            else {
                passwordVerifyShow.value = false;
            }
        };
        const changeHandle = (value) => {
            if (value === "password") {
                password.value = resetData.password;
            }
            else {
                passwordVerify.value = resetData.passwordVerify;
            }
        };
        const captchaRef = ref();
        const validate = () => {
            resetForm.value?.validateField("phone", (valid) => {
                if (valid) {
                    captchaRef.value?.showCaptcha();
                }
            });
        };
        // 获取验证码
        const getCode = debounce(() => {
            isSend.value = true;
            startCountdown();
            getMsg("短信验证码已发送，可能会有延后，请耐心等待", "success");
        }, 500);
        const startCountdown = () => {
            intervalId = setInterval(() => {
                if (count.value > 0) {
                    count.value--;
                }
                else {
                    stopCountdown();
                }
            }, 1000);
        };
        const stopCountdown = () => {
            isSend.value = false;
            clearInterval(intervalId);
        };
        watch(() => props.scenario, (val) => {
            if (val === 4) {
                resetData.phone = userInfo.phone;
            }
            else {
                resetData.phone = "";
            }
        }, { immediate: true });
        onBeforeUnmount(() => {
            stopCountdown();
        });
        expose({
            submit
        });
        return (_ctx, _cache) => {
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_form_item = _resolveComponent("el-form-item");
            const _component_el_button = _resolveComponent("el-button");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(ElForm), {
                    ref_key: "resetForm",
                    ref: resetForm,
                    model: resetData,
                    rules: resetRules,
                    size: "large"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { prop: "phone" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                    modelValue: resetData.phone,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((resetData.phone) = $event)),
                                    disabled: __props.scenario === 4,
                                    placeholder: "请输入您的手机号",
                                    autocomplete: "new-password"
                                }, {
                                    prepend: _withCtx(() => [
                                        _hoisted_1
                                    ]),
                                    _: 1
                                }, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_el_form_item, { prop: "code" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                    _createVNode(_component_el_input, {
                                        modelValue: resetData.code,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((resetData.code) = $event)),
                                        placeholder: "请输入您的验证码"
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_el_button, {
                                        disabled: isSend.value,
                                        onClick: validate
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(isSend.value ? count.value + "秒后重发" : "获取验证码"), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["disabled"])
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_el_form_item, { prop: "password" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                    key: "password",
                                    modelValue: resetData.password,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((resetData.password) = $event)),
                                    autocomplete: "new-password",
                                    placeholder: "新密码",
                                    "show-password": "",
                                    onFocus: _cache[3] || (_cache[3] = ($event) => (focusHandle('password'))),
                                    onBlur: _cache[4] || (_cache[4] = ($event) => (blurHandle('password'))),
                                    onInput: _cache[5] || (_cache[5] = ($event) => (changeHandle('password')))
                                }, null, 8, ["modelValue"]),
                                _withDirectives(_createVNode(PasswordCheck, { value: password.value }, null, 8, ["value"]), [
                                    [_vShow, passwordShow.value]
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_el_form_item, { prop: "passwordVerify" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                    modelValue: resetData.passwordVerify,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((resetData.passwordVerify) = $event)),
                                    placeholder: "确认新密码",
                                    "show-password": "",
                                    onFocus: _cache[7] || (_cache[7] = ($event) => (focusHandle('passwordVerify'))),
                                    onBlur: _cache[8] || (_cache[8] = ($event) => (blurHandle('passwordVerify'))),
                                    onInput: _cache[9] || (_cache[9] = ($event) => (changeHandle('passwordVerify'))),
                                    onKeydown: _withKeys(submit, ["enter"])
                                }, null, 8, ["modelValue", "onKeydown"])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["model", "rules"]),
                _createVNode(_unref(Captcha), {
                    ref_key: "captchaRef",
                    ref: captchaRef,
                    callback: _unref(getCode),
                    phone: resetData.phone,
                    scenario: __props.scenario
                }, null, 8, ["callback", "phone", "scenario"]),
                (__props.isCancel)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(CloudButton, {
                            size: "large",
                            type: "light",
                            onClick: cancelHandle
                        }, {
                            default: _withCtx(() => [
                                _hoisted_4
                            ]),
                            _: 1
                        }),
                        _createVNode(CloudButton, {
                            type: "deep",
                            size: "large",
                            onClick: submit
                        }, {
                            default: _withCtx(() => [
                                _hoisted_5
                            ]),
                            _: 1
                        })
                    ]))
                    : (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        class: "submit-btn",
                        size: "large",
                        type: "primary",
                        onClick: submit
                    }, {
                        default: _withCtx(() => [
                            _hoisted_6
                        ]),
                        _: 1
                    }))
            ], 64));
        };
    }
});
